
























































































import { Component, Prop, Watch, Ref } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { mixins } from "vue-class-component";
import { DataModules } from "@/store/modules/data";
import HasValidation from "@/mixins/HasValidation";
import { IDomain } from "@/models/domains";
import _ from "@/boot/lodash";

interface Form {
  origin: string;
  staff_enabled?: boolean;
  customer_enabled?: boolean;
}

const initialForm = (): Form => {
  return {
    staff_enabled: true,
    customer_enabled: true,
    origin: ""
  };
};

@Component
export default class DomainForm extends mixins(RequestPromises, HasValidation) {
  @Prop({ required: false, default: false })
  public isModal!: boolean;

  @Prop({ required: false, default: "" })
  public domainId!: IDomain["id"];

  public isProcessing = false;
  public loading = true;
  public form: Form = initialForm();
  public initialForm: Form = initialForm();
  @Ref()
  public readonly domainInput!: any;
  public dns = {};
  public isHealthy = true;
  public isCustom = true;

  @Watch("isProcessing")
  public isProcessingChanged() {
    this.$emit("isProcessing", this.isProcessing);
  }
  @Watch("isDisabled")
  public isDisabledChanged() {
    this.$emit("isDisabled", this.isDisabled);
  }

  public get isDisabled() {
    return this.isProcessing || (this.isEdit && !this.isFormChanged);
  }

  public async created() {
    await this.loadData();
    this.loading = false;
    this.isProcessingChanged();
    this.isDisabledChanged();
    if (this.isEdit) {
      return;
    }
    this.$nextTick(() => {
      this.domainInput.focus();
    });
  }

  public getDnsSettings() {
    if (!this.$userCan("get_oauth_client_dns")) {
      return {};
    }
    return this.$store.dispatch(`data/${DataModules.OAUTH_CLIENTS}/getDns`, {
      vm: this
    });
  }

  public async loadData() {
    this.dns = await this.getDnsSettings();
    if (!this.isEdit) {
      return;
    }
    try {
      const domain = await this.$store.dispatch(
        `data/${DataModules.OAUTH_CLIENTS}/get`,
        {
          id: this.domainId,
          storeData: false
        }
      );
      this.isHealthy = domain.origin_healthy;
      this.isCustom = domain.custom;
      this.form = this.$_.pick(domain, [
        "origin",
        "customer_enabled",
        "staff_enabled"
      ]);
      this.initialForm = this.$_.clone(this.form);
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    }
  }

  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      await this[this.isEdit ? "update" : "create"]();
      this.$emit("domain-saved");
      this.$emit("close");
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    } finally {
      this.isProcessing = false;
    }
  }

  public get isEdit() {
    return !!this.domainId;
  }

  public async create() {
    await this.$store.dispatch(`data/${DataModules.OAUTH_CLIENTS}/create`, {
      data: {
        brand_id: this.$store.state.auth.admin.brandId,
        ...this.form
      }
    });
    this.$buefy.toast.open({
      message: this.$t("_.custom_domain_added") as string
    });
  }

  public async update() {
    await this.$store.dispatch(`data/${DataModules.OAUTH_CLIENTS}/update`, {
      id: this.domainId,
      data: {
        ...this.form
      }
    });
    this.$buefy.toast.open({
      message: this.$t("_.domain_settings_updated") as string
    });
  }

  public get isFormChanged(): boolean {
    return !this.$_.isEqual(this.form, this.initialForm);
  }

  public get dnsRecords() {
    return _.flatten(
      _.map(this.dns, (value, type) => {
        if (_.isArray(value)) return _.map(value, v => ({ type, value: v }));
        return { type, value };
      })
    );
  }

  public get showDnsInstructions() {
    if (!this.isCustom) return false;
    if (!this.form.customer_enabled && !this.form.staff_enabled) return false;
    return this.dnsRecords.length && this.form.origin.length;
  }

  public copyToClipboard(value) {
    this.$copyText(value).then(() => {
      this.$buefy.toast.open({
        message: this.$t("_.copied_to_clipboard") as string
      });
    });
  }
}
